import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import HubNav from '../../ResourceHubPages/HubNav/HubNav';
import RetirementHero from './components/RetirementHero';
import SmartRetirementPlanning from './components/SmartRetirementPlanning';
import RetirementCalculatorSection from './components/RetirementCalculatorSection';
import PartnersSection from '../Home/components/PartnersSection';
import CalculatorStatic from '../../401kCalculatorStatic/CalculatorStatic';
import PageHeaders from '../../../Utils/PageHeaders';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    backgroundColor: theme.palette.background.default,
    minHeight: '100vh',
  },
}));

const RetirementSolutions = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <HubNav />
      <PageHeaders
        title="401k & Retirement Planning for Individuals — Free AI Advisor | Plootus"
        description="Take control of your 401(k), 403(b), or 457 plan with Plootus. Our free AI analyzes your employer's retirement plan, recommends the best funds for your risk profile, and helps you retire on time — no financial advisor fees required."
        ogTitle="Free Retirement Planning for Individuals | Plootus"
        ogDescription="Plootus helps individuals optimize their 401k and 403b plans for free — personalized fund picks, fee analysis, and retirement goal tracking in one place."
        canonicalUrl="https://www.plootus.com/individual-users"
      />
      
      <RetirementHero />
      <SmartRetirementPlanning />
      <RetirementCalculatorSection />
      <PartnersSection />
      {/* <FeaturesSection />
      <CalculatorSection /> */}
    </div>
  );
};

export default RetirementSolutions;
